// Open-redirect guard for the post-login redirect flow. A redirect target
// arrives from an untrusted place (URL query, sessionStorage), so before we
// ever navigate to it we confirm it can only point back into this same
// origin — never off to another site.
//
// Ported from the legacy MV-2954 fix (src/app/lib/safeRedirect.js).
//
// Returns a safe same-origin path (pathname + search + hash) or null. Callers
// fall back to their default landing page on null.
export function getSafeRedirectPath(raw) {
  if (!raw || typeof raw !== 'string') return null

  // Must be a plain path. Reject protocol-relative ("//evil.com") and
  // backslash tricks ("/\evil.com") that some browsers normalize to a host.
  if (!raw.startsWith('/') || raw.startsWith('//') || raw.includes('\\')) {
    return null
  }

  try {
    const url = new URL(raw, window.location.origin)
    // Anything that resolves to a different origin (e.g. "http://evil.com",
    // "javascript:...") is rejected.
    if (url.origin !== window.location.origin) return null
    return `${url.pathname}${url.search}${url.hash}`
  } catch {
    return null
  }
}
